import type moment from 'moment';
import { formatDate } from '../../../../common/services/date-helper/service';
import { useAppContext } from '../../../hooks/useAppContext';

export interface Props {
    date: moment.MomentInput;
    format?: string;
    displayTimeZone?: boolean;
    className?: string;
}

export default function ({ date, format, displayTimeZone, className }: Props) {
    const companySettings = useAppContext().user.company.companySettings;
    const formatted = formatDate(date, format, undefined, displayTimeZone, companySettings);
    return <span className={className}>{formatted}</span>;
}
